import React, { useState } from 'react'
import PRMStatusSelector from '../../../../../components/Selectors/PRMStatusSelector'
import { updateProspect } from '../../../../../api/PRMAPI';
import { notifications } from '@mantine/notifications';
import { useLanguage } from '../../../../../stores/LanguageStore';

const PrmCellStatus = ({ row, apiRef }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  const onStatusChange = (newStatus) => {
    setLoading(true);
    let newItem = parseInt(newStatus)
      ? { ...row, custom_status: parseInt(newStatus), status: row.status }
      : { ...row, custom_status: null, status: newStatus };
    updateProspect({
      id: row.id,
      custom_status: newItem.custom_status,
      status: newItem.status,
    })
      .then(() => {
        notifications.show({
          message: lang.prm.prospect_moved,
          color: "tertiary.8",
        });

        apiRef.current?.updateRows([
          {
            ...row,
            id: row.id,
            custom_status: newItem.custom_status,
            status: newItem.status,
          },
        ]);
      })
      .finally(() => setLoading(false));
  };

  return (
    <PRMStatusSelector
      key={row?.custom_status?.toString()}
      value={row?.custom_status?.toString() || row?.status}
      onChange={onStatusChange}
      noLabel={true}
      w={150}
      disabled={loading || !row?.permission?.write_permission}
      required
      withinPortal
    />
  )
}

export default PrmCellStatus